var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable max-lines, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var ArrowPicker = require("./interaction/arrow-picker.jsx");
var ColorPicker = require("./interaction/color-picker.jsx");
var ConstraintEditor = require("./interaction/constraint-editor.jsx");
var DashPicker = require("./interaction/dash-picker.jsx");
var ElementContainer = require("./interaction/element-container.jsx");
var GraphSettings = require("../components/graph-settings.jsx");
var MathInput = require("../components/math-input.jsx");
var NumberInput = require("../components/number-input.jsx");
var TeX = require("react-components/tex.jsx");
var TextInput = require("../components/text-input.jsx");

var KhanColors = require("../util/colors.js");

var defaultInteractionProps = {
    graph: {
        box: [400, 400],
        labels: ["x", "y"],
        range: [[-10, 10], [-10, 10]],
        tickStep: [1, 1],
        gridStep: [1, 1],
        markings: "graph"
    },
    elements: []
};

//
// Editor for non-interactive points
//
// TODO(eater): Factor this out
//
var PointEditor = React.createClass({
    displayName: "PointEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        coordX: React.PropTypes.string,
        coordY: React.PropTypes.string,
        color: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            coordX: "0",
            coordY: "0",
            color: KhanColors.BLACK
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Coordinate: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.coordX,
                    onChange: this.change("coordX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.coordY,
                    onChange: this.change("coordY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(ColorPicker, {
                    value: this.props.color,
                    onChange: this.change("color")
                })
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for non-interactive line segments
//
// TODO(eater): Factor this out
//
var LineEditor = React.createClass({
    displayName: "LineEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        startX: React.PropTypes.string,
        startY: React.PropTypes.string,
        endX: React.PropTypes.string,
        endY: React.PropTypes.string,
        color: React.PropTypes.string,
        strokeDasharray: React.PropTypes.string,
        arrows: React.PropTypes.string,
        strokeWidth: React.PropTypes.number
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            startX: "-5",
            startY: "5",
            endX: "5",
            endY: "5",
            color: KhanColors.BLACK,
            strokeDasharray: "",
            arrows: "",
            strokeWidth: 2
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Start: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.startX,
                    onChange: this.change("startX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.startY,
                    onChange: this.change("startY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "End: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.endX,
                    onChange: this.change("endX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.endY,
                    onChange: this.change("endY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(ColorPicker, {
                    value: this.props.color,
                    onChange: this.change("color")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(DashPicker, {
                    value: this.props.strokeDasharray,
                    onChange: this.change("strokeDasharray")
                }),
                "\xA0 \xA0",
                React.createElement(ArrowPicker, {
                    value: this.props.arrows,
                    onChange: this.change("arrows")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    "Width:",
                    " ",
                    React.createElement(NumberInput, {
                        value: this.props.strokeWidth,
                        placeholder: 2,
                        onChange: this.change("strokeWidth")
                    })
                )
            )
        );
    },

    change: function change() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for interactive movable points
//
// TODO(eater): Factor this out
// TODO(eater): Rethink how constraints are represented
//
var MovablePointEditor = React.createClass({
    displayName: "MovablePointEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        startX: React.PropTypes.string,
        startY: React.PropTypes.string,
        constraint: React.PropTypes.string,
        snap: React.PropTypes.number,
        constraintFn: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            startX: "0",
            startY: "0",
            constraint: "none",
            snap: 0.5,
            constraintFn: "0",
            constraintXMin: "-10",
            constraintXMax: "10",
            constraintYMin: "-10",
            constraintYMax: "10"
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Start: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.startX,
                    onChange: this.change("startX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.startY,
                    onChange: this.change("startY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Update ",
                React.createElement(
                    TeX,
                    null,
                    "(x_n, y_n)"
                ),
                " for ",
                React.createElement(
                    TeX,
                    null,
                    "n ="
                ),
                " ",
                React.createElement(NumberInput, {
                    value: this.props.varSubscript,
                    placeholder: 0,
                    onChange: this.change("varSubscript")
                })
            ),
            React.createElement(ConstraintEditor, this.props)
        );
    },

    change: function change() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for interactive movable line segments
//
// TODO(eater): Factor this out
// TODO(eater): Rethink how constraints are represented
//
var MovableLineEditor = React.createClass({
    displayName: "MovableLineEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        startX: React.PropTypes.string,
        startY: React.PropTypes.string,
        endX: React.PropTypes.string,
        endY: React.PropTypes.string,
        constraint: React.PropTypes.string,
        snap: React.PropTypes.number,
        constraintFn: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            startX: "-5",
            startY: "5",
            endX: "5",
            endY: "5",
            constraint: "none",
            snap: 0.5,
            constraintFn: "0",
            constraintXMin: "-10",
            constraintXMax: "10",
            constraintYMin: "-10",
            constraintYMax: "10"
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            "Initial position:",
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Start: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.startX,
                    onChange: this.change("startX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.startY,
                    onChange: this.change("startY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "End: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.endX,
                    onChange: this.change("endX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.endY,
                    onChange: this.change("endY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Start updates ",
                React.createElement(
                    TeX,
                    null,
                    "(x_n, y_n)"
                ),
                " for ",
                React.createElement(
                    TeX,
                    null,
                    "n ="
                ),
                React.createElement(NumberInput, {
                    value: this.props.startSubscript,
                    placeholder: 0,
                    onChange: this.change("startSubscript")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "End updates ",
                React.createElement(
                    TeX,
                    null,
                    "(x_m, y_m)"
                ),
                " for ",
                React.createElement(
                    TeX,
                    null,
                    "m ="
                ),
                React.createElement(NumberInput, {
                    value: this.props.endSubscript,
                    placeholder: 0,
                    onChange: this.change("endSubscript")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "All constraints are applied to the start point."
            ),
            React.createElement(ConstraintEditor, this.props)
        );
    },

    change: function change() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for function plots
//
// TODO(eater): Factor this out
//
var FunctionEditor = React.createClass({
    displayName: "FunctionEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        value: React.PropTypes.string,
        rangeMin: React.PropTypes.string,
        rangeMax: React.PropTypes.string,
        color: React.PropTypes.string,
        strokeDashArray: React.PropTypes.string,
        strokeWidth: React.PropTypes.number
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            value: "x",
            rangeMin: "-10",
            rangeMax: "10",
            color: KhanColors.BLUE,
            strokeDasharray: "",
            strokeWidth: 2
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    TeX,
                    null,
                    this.props.funcName + "(x)="
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.value,
                    onChange: this.change("value")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Range: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.rangeMin,
                    onChange: this.change("rangeMin")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.rangeMax,
                    onChange: this.change("rangeMax")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(ColorPicker, {
                    value: this.props.color,
                    onChange: this.change("color")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(DashPicker, {
                    value: this.props.strokeDasharray,
                    onChange: this.change("strokeDasharray")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    "Width:",
                    " ",
                    React.createElement(NumberInput, {
                        value: this.props.strokeWidth,
                        placeholder: 2,
                        onChange: this.change("strokeWidth")
                    })
                )
            )
        );
    },

    change: function change() {
        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for parametric plots
//
// TODO(eater): Factor this out
//
var ParametricEditor = React.createClass({
    displayName: "ParametricEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        x: React.PropTypes.string,
        y: React.PropTypes.string,
        rangeMin: React.PropTypes.string,
        rangeMax: React.PropTypes.string,
        color: React.PropTypes.string,
        strokeDashArray: React.PropTypes.string,
        strokeWidth: React.PropTypes.number
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            x: "cos(t)",
            y: "sin(t)",
            rangeMin: "0",
            rangeMax: "2\\pi",
            color: KhanColors.BLUE,
            strokeDasharray: "",
            strokeWidth: 2
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    TeX,
                    null,
                    "X(t) ="
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.x,
                    onChange: this.change("x")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    TeX,
                    null,
                    "Y(t) ="
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.y,
                    onChange: this.change("y")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Range: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.rangeMin,
                    onChange: this.change("rangeMin")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.rangeMax,
                    onChange: this.change("rangeMax")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(ColorPicker, {
                    value: this.props.color,
                    onChange: this.change("color")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(DashPicker, {
                    value: this.props.strokeDasharray,
                    onChange: this.change("strokeDasharray")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    "Width:",
                    " ",
                    React.createElement(NumberInput, {
                        value: this.props.strokeWidth,
                        placeholder: 2,
                        onChange: this.change("strokeWidth")
                    })
                )
            )
        );
    },

    change: function change() {
        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for labels
//
// TODO(eater): Factor this out maybe?
// TODO(eater): Add text direction
//
var LabelEditor = React.createClass({
    displayName: "LabelEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        color: React.PropTypes.string,
        coordX: React.PropTypes.string,
        coordY: React.PropTypes.string,
        label: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            coordX: "0",
            coordY: "0",
            color: KhanColors.BLACK,
            label: "\\phi"
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(TextInput, {
                    value: this.props.label,
                    onChange: this.change("label"),
                    style: {
                        width: "100%"
                    }
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Location: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.coordX,
                    onChange: this.change("coordX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.coordY,
                    onChange: this.change("coordY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(ColorPicker, {
                    value: this.props.color,
                    onChange: this.change("color")
                })
            )
        );
    },

    change: function change() {
        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            args[_key7] = arguments[_key7];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

//
// Editor for rectangles
//
// TODO(eater): Factor this out maybe?
//
var RectangleEditor = React.createClass({
    displayName: "RectangleEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        color: React.PropTypes.string,
        coordX: React.PropTypes.string,
        coordY: React.PropTypes.string,
        height: React.PropTypes.string,
        width: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            coordX: "-5",
            coordY: "5",
            width: "2",
            height: "3",
            color: KhanColors.LIGHT_BLUE
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "graph-settings" },
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Bottom left: ",
                React.createElement(
                    TeX,
                    null,
                    "\\Large("
                ),
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.coordX,
                    onChange: this.change("coordX")
                }),
                React.createElement(
                    TeX,
                    null,
                    ","
                ),
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.coordY,
                    onChange: this.change("coordY")
                }),
                React.createElement(
                    TeX,
                    null,
                    "\\Large)"
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Width:",
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.width,
                    onChange: this.change("width")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "Height:",
                " ",
                React.createElement(MathInput, {
                    buttonSets: [],
                    buttonsVisible: "never",
                    value: this.props.height,
                    onChange: this.change("height")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(ColorPicker, {
                    value: this.props.color,
                    lightColors: true,
                    onChange: this.change("color")
                })
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                "You want a border? Sorry, draw your own."
            )
        );
    },

    change: function change() {
        for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            args[_key8] = arguments[_key8];
        }

        return Changeable.change.apply(this, args);
    },
    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

var InteractionEditor = React.createClass({
    displayName: "InteractionEditor",

    // TODO(eater): Make more better
    propTypes: _extends({}, Changeable.propTypes, {
        elements: React.PropTypes.arrayOf(React.PropTypes.object),
        graph: React.PropTypes.objectOf(React.PropTypes.any)
    }),

    getDefaultProps: function getDefaultProps() {
        return defaultInteractionProps;
    },

    getInitialState: function getInitialState() {
        return {
            usedVarSubscripts: this._getAllVarSubscripts(this.props.elements),
            usedFunctionNames: this._getAllFunctionNames(this.props.elements)
        };
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({
            usedVarSubscripts: this._getAllVarSubscripts(nextProps.elements),
            usedFunctionNames: this._getAllFunctionNames(nextProps.elements)
        });
    },

    _getAllVarSubscripts: function _getAllVarSubscripts(elements) {
        return _.map(_.where(elements, { type: "movable-point" }), function (element) {
            return element.options.varSubscript;
        }).concat(_.map(_.where(elements, { type: "movable-line" }), function (element) {
            return element.options.startSubscript;
        })).concat(_.map(_.where(elements, { type: "movable-line" }), function (element) {
            return element.options.endSubscript;
        }));
    },

    _getAllFunctionNames: function _getAllFunctionNames(elements) {
        return _.map(_.where(elements, { type: "function" }), function (element) {
            return element.options.funcName;
        });
    },

    _updateGraphProps: function _updateGraphProps(newProps) {
        // TODO(eater): GraphSettings should name this tickStep instead
        // of step. Grr..
        this.change({
            graph: _.extend(_.omit(newProps, "step"), {
                tickStep: newProps.step
            })
        });
    },

    _addNewElement: function _addNewElement(e) {
        var elementType = e.target.value;
        if (elementType === "") {
            return;
        }
        e.target.value = "";
        var newElement = {
            type: elementType,
            key: elementType + "-" + (Math.random() * 0xffffff << 0).toString(16),
            options: elementType === "point" ? _.clone(PointEditor.defaultProps) : elementType === "line" ? _.clone(LineEditor.defaultProps) : elementType === "movable-point" ? _.clone(MovablePointEditor.defaultProps) : elementType === "movable-line" ? _.clone(MovableLineEditor.defaultProps) : elementType === "function" ? _.clone(FunctionEditor.defaultProps) : elementType === "parametric" ? _.clone(ParametricEditor.defaultProps) : elementType === "label" ? _.clone(LabelEditor.defaultProps) : elementType === "rectangle" ? _.clone(RectangleEditor.defaultProps) : {}
        };

        var nextSubscript;
        if (elementType === "movable-point") {
            nextSubscript = _.max([_.max(this.state.usedVarSubscripts), -1]) + 1;
            newElement.options.varSubscript = nextSubscript;
        } else if (elementType === "movable-line") {
            nextSubscript = _.max([_.max(this.state.usedVarSubscripts), -1]) + 1;
            newElement.options.startSubscript = nextSubscript;
            newElement.options.endSubscript = nextSubscript + 1;
        } else if (elementType === "function") {
            // TODO(eater): The 22nd function added will be {(x) since '{'
            // comes after 'z'
            var nextLetter = String.fromCharCode(_.max([_.max(_.map(this.state.usedFunctionNames, function (c) {
                return c.charCodeAt(0);
            })), "e".charCodeAt(0)]) + 1);
            newElement.options.funcName = nextLetter;
        }
        this.change({
            elements: this.props.elements.concat(newElement)
        });
    },

    _deleteElement: function _deleteElement(index) {
        var element = this.props.elements[index];
        this.change({ elements: _.without(this.props.elements, element) });
    },

    _moveElementUp: function _moveElementUp(index) {
        var element = this.props.elements[index];
        var newElements = _.without(this.props.elements, element);
        newElements.splice(index - 1, 0, element);
        this.change({ elements: newElements });
    },

    _moveElementDown: function _moveElementDown(index) {
        var element = this.props.elements[index];
        var newElements = _.without(this.props.elements, element);
        newElements.splice(index + 1, 0, element);
        this.change({ elements: newElements });
    },

    change: function change() {
        for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        /* eslint-disable max-len */
        return React.createElement(
            "div",
            { className: "perseus-widget-interaction-editor" },
            React.createElement(
                ElementContainer,
                { title: "Grid settings" },
                React.createElement(GraphSettings, {
                    editableSettings: ["canvas", "graph"],
                    box: this.props.graph.box,
                    labels: this.props.graph.labels,
                    range: this.props.graph.range,
                    step: this.props.graph.tickStep,
                    gridStep: this.props.graph.gridStep,
                    markings: this.props.graph.markings,
                    onChange: this._updateGraphProps
                }),
                this.props.graph.valid !== true && React.createElement(
                    "div",
                    null,
                    this.props.graph.valid
                )
            ),
            _.map(this.props.elements, function (element, n) {
                var _this = this;

                if (element.type === "movable-point") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Movable point",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(x_{" + element.options.varSubscript + "}, y_{" + element.options.varSubscript + "})"
                                )
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement.bind(this, n),
                            key: element.key
                        },
                        React.createElement(MovablePointEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "movable-line") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Movable line",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(x_{" + element.options.startSubscript + "}, y_{" + element.options.startSubscript + "})"
                                ),
                                " ",
                                "to",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(x_{" + element.options.endSubscript + "}, y_{" + element.options.endSubscript + "})"
                                )
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement.bind(this, n),
                            key: element.key
                        },
                        React.createElement(MovableLineEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "point") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Point",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(" + element.options.coordX + ", " + element.options.coordY + ")"
                                )
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement.bind(this, n),
                            key: element.key
                        },
                        React.createElement(PointEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "line") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Line",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(" + element.options.startX + ", " + element.options.startY + ")"
                                ),
                                " ",
                                "to",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(" + element.options.endX + ", " + element.options.endY + ")"
                                )
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement.bind(this, n),
                            key: element.key
                        },
                        React.createElement(LineEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "function") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Function",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    element.options.funcName + "(x) = " + element.options.value
                                )
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement,
                            key: element.key
                        },
                        React.createElement(FunctionEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "parametric") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Parametric"
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement,
                            key: element.key
                        },
                        React.createElement(ParametricEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "label") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Label",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    element.options.label
                                ),
                                " "
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement,
                            key: element.key
                        },
                        React.createElement(LabelEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                } else if (element.type === "rectangle") {
                    return React.createElement(
                        ElementContainer,
                        {
                            title: React.createElement(
                                "span",
                                null,
                                "Rectangle",
                                " ",
                                React.createElement(
                                    TeX,
                                    null,
                                    "(" + element.options.coordX + ", " + element.options.coordY + ")"
                                ),
                                "\xA0\u2014\xA0",
                                React.createElement(
                                    TeX,
                                    null,
                                    element.options.width + " \\times " + element.options.height
                                )
                            ),
                            onUp: n === 0 ? null : this._moveElementUp.bind(this, n),
                            onDown: n === this.props.elements.length - 1 ? null : this._moveElementDown.bind(this, n),
                            onDelete: this._deleteElement,
                            key: element.key
                        },
                        React.createElement(RectangleEditor, _extends({}, element.options, {
                            onChange: function onChange(newProps) {
                                var elements = JSON.parse(JSON.stringify(_this.props.elements));
                                _.extend(elements[n].options, newProps);
                                _this.change({ elements: elements });
                            }
                        }))
                    );
                }
            }, this),
            React.createElement(
                "div",
                { className: "perseus-widget-interaction-editor-select-element" },
                React.createElement(
                    "select",
                    { onChange: this._addNewElement },
                    React.createElement(
                        "option",
                        { value: "" },
                        "Add an element",
                        "\u2026"
                    ),
                    React.createElement(
                        "option",
                        { disabled: true },
                        "--"
                    ),
                    React.createElement(
                        "option",
                        { value: "point" },
                        "Point"
                    ),
                    React.createElement(
                        "option",
                        { value: "line" },
                        "Line segment"
                    ),
                    React.createElement(
                        "option",
                        { value: "function" },
                        "Function plot"
                    ),
                    React.createElement(
                        "option",
                        { value: "parametric" },
                        "Parametric plot"
                    ),
                    React.createElement(
                        "option",
                        { value: "label" },
                        "Label"
                    ),
                    React.createElement(
                        "option",
                        { value: "rectangle" },
                        "Rectangle"
                    ),
                    React.createElement(
                        "option",
                        { value: "movable-point" },
                        "\u2605 Movable point"
                    ),
                    React.createElement(
                        "option",
                        { value: "movable-line" },
                        "\u2605 Movable line segment"
                    )
                )
            )
        );
        /* eslint-enable max-len */
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = InteractionEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/interaction-editor.jsx
 ** module id = 117
 ** module chunks = 0 1
 **/